import React from 'react';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: June 2025</p>
          
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using the KenkoSnap mobile application ("App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              KenkoSnap is an AI-powered health and nutrition tracking application that allows users to:
            </p>
            <ul>
              <li>Analyze meal nutritional content through photo recognition</li>
              <li>Track body weight and composition</li>
              <li>Set and monitor health goals</li>
              <li>View progress analytics and insights</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts and Registration</h2>
            <p>
              To use certain features of the App, you may be required to create an account. You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information</li>
              <li>Updating your information as necessary</li>
            </ul>
          </section>

          <section>
            <h2>4. Health Information and Medical Disclaimer</h2>
            <p>
              <strong>IMPORTANT:</strong> KenkoSnap is not a medical device and is not intended to diagnose, treat, cure, or prevent any disease. The App provides general health and nutrition information for educational purposes only.
            </p>
            <ul>
              <li>Always consult with healthcare professionals before making health decisions</li>
              <li>AI-generated nutritional analysis may not be 100% accurate</li>
              <li>Individual health needs vary - the App cannot replace professional medical advice</li>
              <li>In case of medical emergencies, contact emergency services immediately</li>
            </ul>
          </section>

          <section>
            <h2>5. User Content and Data</h2>
            <p>
              You retain ownership of the content you submit to the App, including photos and health data. By using the App, you grant us a limited license to:
            </p>
            <ul>
              <li>Process your photos for nutritional analysis</li>
              <li>Store your health data securely</li>
              <li>Use aggregated, anonymized data to improve our services</li>
            </ul>
            <p>
              We are committed to protecting your privacy. Please review our Privacy Policy for details on how we collect, use, and protect your information.
            </p>
          </section>

          <section>
            <h2>6. Prohibited Uses</h2>
            <p>You agree not to use the App to:</p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Share inappropriate, offensive, or harmful content</li>
              <li>Attempt to reverse engineer or hack the App</li>
              <li>Use the App for commercial purposes without authorization</li>
              <li>Share your account with others</li>
              <li>Upload malicious code or attempt to disrupt the service</li>
            </ul>
          </section>

          <section>
            <h2>7. Subscription and Payment Terms</h2>
            <p>
              KenkoSnap may offer premium features through subscription plans:
            </p>
            <ul>
              <li>Subscriptions are billed through your Apple ID account</li>
              <li>Payment will be charged to your iTunes Account at confirmation of purchase</li>
              <li>Subscriptions automatically renew unless auto-renew is turned off at least 24 hours before the end of the current period</li>
              <li>You can manage subscriptions and turn off auto-renewal in your Apple ID Account Settings</li>
              <li>No refunds for unused portions of subscription periods</li>
            </ul>
          </section>

          <section>
            <h2>8. Fair Use Policy</h2>
            <p>
              To ensure optimal service quality for all users, KenkoSnap implements a Fair Use Policy for Premium subscribers. Each Premium subscription includes up to 300 image analyses per monthly billing cycle. Once this limit is reached, further image analyses will be paused until the next billing cycle begins.
            </p>
            <p>
              If you consistently require a higher usage limit, please contact us at premium@kenkosnap.com so we can discuss a plan that better suits your needs.
            </p>
          </section>

          <section>
            <h2>9. Intellectual Property</h2>
            <p>
              The App and its original content, features, and functionality are owned by KenkoSnap and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2>10. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. We collect and process your personal information in accordance with our Privacy Policy and applicable data protection laws, including GDPR and CCPA where applicable.
            </p>
          </section>

          <section>
            <h2>11. Disclaimers and Limitations of Liability</h2>
            <p>
              THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. TO THE FULLEST EXTENT PERMITTED BY LAW:
            </p>
            <ul>
              <li>We disclaim all warranties, express or implied</li>
              <li>We are not liable for any indirect, incidental, or consequential damages</li>
              <li>Our total liability shall not exceed the amount paid by you for the App</li>
              <li>We do not guarantee the accuracy of AI-generated nutritional information</li>
            </ul>
          </section>

          <section>
            <h2>12. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless KenkoSnap from any claims, damages, or expenses arising from your use of the App or violation of these Terms.
            </p>
          </section>

          <section>
            <h2>13. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the App at our sole discretion, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </p>
          </section>

          <section>
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify users of significant changes through the App or other communication methods. Continued use of the App after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2>15. Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2>16. Contact Information</h2>
            <p>
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <div className="contact-info">
              <p>Email: legal@kenkosnap.com</p>
              <p>Website: https://kenkosnap.com</p>
            </div>
          </section>

          <div className="back-link">
            <a href="/">← Back to KenkoSnap</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService; 